import { Component, OnInit, NgZone  } from '@angular/core';
import { DataService } from '../../data.service';
import { ActivatedRoute, Router } from '@angular/router';
//import { element } from 'protractor';


@Component({
  selector: 'app-generate-bill',
  templateUrl: './generate-bill.component.html',
  styleUrls: ['./generate-bill.component.scss']
})
export class GenerateBillComponent implements OnInit {

  constructor(private router:Router, private route: ActivatedRoute, private dataService: DataService, private ngZone: NgZone) { }

  patient:any = {patient_id:0, patient_name:"", phone:""};
  id:any = 0;
  appointmentId:any = 0;
  billContents:any = [
    {description:"", rate:"", qty:1, amount:"", is_therapy:0, therapist:0, duration:""},
  ];
  totalAmt:any = 0;
  therapists:any = [];
  selectedTherapist:any = 0;
  billHeads:any = [];
  billHeadType:any = 1;
  others:any = [];
  labels:any = [];
  selectedLabel:any = 0;
  paidForVisitID:any = 0;
  billType:any = "";
  billTypes:any = [];
  billTypeObj = {id:0, name:""}

  ngOnInit() {
    
    this.billType = (this.route.snapshot.paramMap.get('mode') != null) ? this.route.snapshot.paramMap.get('mode') : 1;
    this.id = (this.route.snapshot.paramMap.get('id') != null) ? this.route.snapshot.paramMap.get('id') : 0;
    this.appointmentId = (this.route.snapshot.paramMap.get('appointmentId') != null) ? this.route.snapshot.paramMap.get('appointmentId') : 0;
    this.loadBillTypes();
    this.loadPatient();
    this.loadAppointment();
    this.loadTherapists();
    this.loadBillHeads();
    this.loadBillLabels();
    
    let context = this;
    //@ts-ignore
    if(this.dataService.localData.roleId == 3 || this.dataService.localData.roleId == 4){
      this.selectedTherapist = this.dataService.localData.userId;
    }

    if(this.dataService.localData.billContents.length > 0){
      this.billContents = this.dataService.localData.billContents;

      this.billContents.forEach(element => {
        this.totalAmt += Number(element.amount);
      });

      this.billContents.some(elem => {
        if(elem.hasOwnProperty('visit_id')){
          this.paidForVisitID = elem.visit_id;
        }
      })
    }

    //Autocomplete

    $('body').on('focus', '#inputPatient', function(){
      let moi = $(this);
      let branch = (localStorage.getItem("branch") !== null ) ? JSON.parse(localStorage.getItem("branch")) : {id:0, name:""};
      //@ts-ignore
      moi.autocomplete({
        //appendTo: '#addAppointment',
        source: function(request, response) {
            $.ajax({
              url:context.dataService.REST_API_SERVER + 'patient/autocomplete',
              type:'GET',
              dataType:'json',
              data: {term: request.term, branch:branch.id},
              headers: {key:localStorage.getItem('key')},
              success: function(responseData) {
                
                var array = responseData.map(function(element){
                  return {value: element['value'] , op_number: element['op_number'], patient_id: element['patient_id'], patient_name: element['patient_name'], phone: element['phone']};
                });
                response(array);
    
              }
            })
          }, 
          select: function(event, ui) {
              moi.val(ui.item.patient_name);
              context.ngZone.run(() => {
                context.router.navigate(['/dashboard/generate-bill/'+context.billType+'/'+ui.item.patient_id]);
              });

              
              
              return false;
          }
      });
    });
    


  }

  loadPatient(){
    this.dataService.getPatientProfile(this.id).subscribe( (data: any = {status:0} )=> {
      if(data.status == 0){
        this.patient = data;
      }
      
    });
  }

  loadBillLabels(){
    this.dataService.getBillLabels().subscribe( (data: any  )=> {
      this.labels = data
      
    });
  }

  loadBillTypes(){
    this.dataService.getBillTypes().subscribe( (data: any  )=> {
      this.billTypes = data
      this.billTypeObj= data.find(item => item.id == this.billType);
      
    });
  }

  loadAppointment(){

    if(this.appointmentId != 0){
      this.dataService.getBillingAppointment(this.appointmentId).subscribe( (data: any = {status:0} )=> {
        if(data.status == 0){
          this.selectedTherapist = data.therapist_id;
        }
        
        
      });
    }

    
  }

  loadTherapists(){
    this.dataService.getTherapists(0, 1).subscribe( (data: any = {status:0} )=> {
      if(data.status == 0){
        this.therapists = data;
        console.log(data);
      }
      
      
    });
  }

  addBillRow(){
    this.billContents.push({description:"", rate:"", qty:1, amount:"", is_therapy:0, therapist:0, duration:""});
  }

  removeBillRow(index){
    this.billContents.splice(index, 1);
  }

  generateBill(){
    $('#btn-submit').attr('disabled', 'true');
    $('#btn-submit').text('Submitting');
    var data = {
      patient_id: this.id,
      billcontents:this.billContents,
      therapist:this.selectedTherapist,
      appointmentId: this.appointmentId,
      label:this.selectedLabel,
      paidForVisitID:this.paidForVisitID,
      billType:this.billTypeObj
    };

    

    if(this.billContents.length > 0){
      this.dataService.postBill(data).subscribe( (res:any) => {
        $('#btn-submit').removeAttr('disabled');
        $('#btn-submit').text('generate Bll');

        if(res.status == 0) {
          alert(res.msg);
          this.dataService.localData.billContents = [];
          this.router.navigate(['/dashboard/bill/'+res.bill_id]);
          
          
        } else {
          alert(res.msg);
        }

      }); 
    }

  }
  
  calculateAmount(index){
    var rate = this.billContents[index].rate;
    var qty = this.billContents[index].qty;
    var amt = 0;
    var total = 0;

    if(!isNaN(rate) && !isNaN(qty) ){
      amt = rate * qty;
      this.billContents[index].amount = amt;

      
    } else {
      amt = 0;
    }

    this.billContents.forEach(element => {
      
      if(!isNaN(element.amount) && element.amount != null && element.amount != ""){
        total += Number(element.amount);
        
      }

      
    });
  
    this.totalAmt = total;

    
  }

  toggleTherapy(index){
    if(this.billContents[index].is_therapy == 1 ) {
      this.billContents[index].is_therapy = 0;
    } else {
      this.billContents[index].is_therapy = 1;
    }
  }

  selectBcTherapist(index, id){
    if(id != 0){
      this.billContents[index].is_therapy = 1;
    }
  }

  loadBillHeads(){

    if(this.billType == 1){
      this.dataService.getBillHeads().subscribe( (data: any = {status:0} )=> {
        this.billHeads = data;  
      });
    } else if(this.billType == 7){
      this.dataService.getProcedureBillHeads().subscribe( (data: any = {status:0} )=> {
        this.billHeads = data;   
      });
    }

    
  }

  setBillHead(i, j){
    
    if(this.billHeads.data[j].id == 'others'){
      this.others.push(i);
      $("input[name=description"+i+"]").focus();
    } else {
      this.billContents[i].description = this.billHeads.data[j].title;
      this.billContents[i].rate = this.billHeads.data[j].amount;
      this.billContents[i].is_therapy = this.billHeads.data[j].is_therapy;
      this.calculateAmount(i);
    }

  }

  findBillHead(i, description){
    let head = this.billHeads.data.find(item => item.title === description);
    if(head != null){
      this.billContents[i].description = head.title;
      this.billContents[i].rate = head.amount;
      this.billContents[i].is_therapy = head.is_therapy;
      this.calculateAmount(i);
    }
  }

  removeFreeText(i){
    if(this.others.indexOf(i) >= 0 ){
      this.others.splice(this.others.indexOf(i), 1);
    }
  }

  

}
